import React from 'react'
import gql from 'graphql-tag'
import { useGlobalContext } from 'components/context'
import { useQuery } from 'react-apollo'
import PieMetric from '../../types/pie'
import { FieldGroupMetric, FieldGroupMetricVariables } from './gql-types/FieldGroupMetric'
import MetricPlaceholder from '../metric-placeholder'


const QUERY = gql`
	query FieldGroupMetric($id: ID!, $teamId: ID) {
		fieldGroupMetric(id: $id) {
			id
			name
			values(teamId: $teamId) {
				name
				formLinks {
					form {
						id
						title
					}
					record {
						id
						name
					}
					field {
						id
						title
					}
				}
			}
		}
	}
`


type Props = {
	id: string
}

const FieldGroupMetricWrapper = ({ id }: Props) => {
	const globalContext = useGlobalContext()
	const { loading, data } = useQuery<FieldGroupMetric, FieldGroupMetricVariables>(QUERY, {variables: {id, teamId: globalContext.currentTeam?.id}})
	if (loading) {
		return <MetricPlaceholder />
	}
	if (!data || !data.fieldGroupMetric) {
		return <div>error</div>
	}
	return (
		<PieMetric {...data?.fieldGroupMetric} />
	)

}

export default FieldGroupMetricWrapper